import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { NewConversationForm } from '../new-conversation-form';

interface Props {
  isVisible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}
export const NewConversationModal: FC<Props> = ({
  isVisible,
  onCancel,
  onSuccess,
}) => {
  return (
    <Modal
      width={462}
      visible={isVisible}
      confirmLoading={false}
      onCancel={onCancel}
      footer={null}
      title={<FormattedMessage id="projects.conversations.new_shared" />}
    >
      <NewConversationForm onSuccess={onSuccess} />
    </Modal>
  );
};
